import React from "react";

import "./App.css";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import HomeCover from "./views/HomeCover";
import Home from "./views/Home";

function App() {
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route exact path="/">
            <HomeCover />
          </Route>
          <Route exact path="/main">
            <Home />
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
